import { render, staticRenderFns } from "./ShopsList.vue?vue&type=template&id=0eb84bad&"
import script from "./ShopsList.vue?vue&type=script&lang=js&"
export * from "./ShopsList.vue?vue&type=script&lang=js&"
import style0 from "./ShopsList.vue?vue&type=style&index=0&id=0eb84bad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports